import Vue from 'vue'
import Vuex from 'vuex'
import Api from '../api/index.js'; //axios
import {
    Dialog
} from 'vant';
Vue.use(Vuex)

export default new Vuex.Store({
    // store刷新后数据会重载 所以用localStorage保存在本地
    state:sessionStorage.getItem("state") ? JSON.parse(sessionStorage.getItem("state")):{
        pagefrom:null,
    },
    mutations: {
        pagefrom:(state,val)=>{
            state.pagefrom = val;
        },
    },
    actions: {
    },
    getters: {},
    modules: {},

})



// WEBPACK FOOTER //
// ./src/store/index.js